import { computed, observable } from "mobx";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { DownloadButtonListTiny } from "../Buttons/DownloadButtonListTiny";
import { EditButtonListTiny } from "../Buttons/EditButtonListTiny";
import { FavouriteButtonListTiny } from "../Buttons/FavouriteButtonListTiny";
import { Link } from "../General/Link";
import { DocumentPreviewIcon } from "../Icons/DocumentPreviewIcon";
import { IconType, MimeTypeIcon } from "../Icons/MimeTypeIcon";
import { AppStore } from "../Stores/AppStore";
import { getDisplayMimetype, getDeepLinkReaderUrl } from "../Utilities";
import { DocumentsViewEntry, handleLoadMore, IDocumentsView, IDocumentsViewEntryPropsBase } from "./DocumentsView";

interface IDocumentPreviews {
	store?: IDocumentsView;
}

@inject('store')
@observer
export class DocumentPreviews extends React.Component<IDocumentPreviews, {}> {

	@observable hoveredDocumentId: string;

	handleLoadMore = (o: any) => {
		handleLoadMore(o, this.props.store);
	}

	onMouseEnter = (documentId: string) => {
		this.hoveredDocumentId = documentId;
	}

	onMouseLeave = () => {
		this.hoveredDocumentId = null;
	}

	render() {
		return <div className="area-grid__body-content" onScroll={this.handleLoadMore}>
			<div className="documentpreview">
				{
					this.props.store.searchResult.documents.length > 0 ?
						<div data-test-id="documentPreviews" className="documentpreview__container">
							{
								this.props.store.searchResult.documents.map((document, index) => {
									return <DocumentPreview key={document.fileLinkGuid + index} fileResult={document} applyUpdatesToModel={false} />;
								})
							}
						</div> :
						!this.props.store.isBusy ?
							<div className="inside__note">
								{this.props.store.noResultMsg}
							</div> : null
				}

				{
					this.props.store.isBusy ? <div className="spinner">
						<div className="spinner-inner">
							<i>
								<svg className="spinner-animation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
									<path className="spinner-custom" d="M24,5A19,19,0,0,1,43,24h3A22,22,0,0,0,24,2Z" />
									<path d="M24,43A19,19,0,0,1,24,5V2A22,22,0,1,0,46,24H43A19,19,0,0,1,24,43Z" />
								</svg>
							</i>
						</div>
						<div className="spinner-label">Loading...</div>
					</div> : null
				}
			</div>
		</div>;
	}
}

@inject('store')
@observer
class DocumentPreview extends DocumentsViewEntry<IDocumentsViewEntryPropsBase> {

	@computed get className(): string {
		return this.props.fileResult.isCoverAvailable ? "preview-item" : "preview-item is--no-preview";
	}

	render() {
		return <div className={this.className}>
			<Link to={getDeepLinkReaderUrl(this.props.fileResult.documentId, this.props.fileResult.language, this.props.fileResult.values[0], this.props.fileResult.mimeType)} className={"link-document preview-item-inner" + (this.props.fileResult.isCoverAvailable ? "" : " is--no-preview")} title={this.props.fileResult.values[0]}>
				<DocumentPreviewIcon fileResult={this.props.fileResult} />
			</Link>
			<div className="preview-item__details preview-item__details-header">
				<span>
					<FavouriteButtonListTiny switchState={this.favouriteState} onClick={this.handleAddFavourites} />
				</span>
				<span className="preview-item__additional">
					{AppStore.context.sessionDetails.isApp ? <DownloadButtonListTiny switchState={this.props.fileResult.status} onClick={this.handleRequestDownload} /> : null}
					{AppStore.context.sessionDetails.isDocumentManager && !AppStore.context.sessionDetails.isApp ? <EditButtonListTiny onClick={this.handleEditDocument} /> : null}
				</span>
			</div>
			<div className="preview-item__details preview-item__details-bottombar">
				<span className="preview-item__mimetype">
					<MimeTypeIcon mimeType={getDisplayMimetype(this.props.fileResult.mimeType)} iconType={IconType.Png16} />
				</span>
				<span className="preview-item__details-filename" title={this.props.fileResult.values[0]}>
					{this.props.fileResult.values[0]}
				</span>
			</div>
		</div>;
	}
}